<template>
    <div>
        <div v-if="model === false">
            <div class="totalmakeHole" ref="total">
                <div class="makeHole1">
                    <div class="topback"
                        :style="{ height: '6vh', backgroundColor: scrollback ? 'rgb(245 244 246)' : 'rgb(245 244 246)', position: 'fixed' }">
                        <headtip :changeVisable="changeVisable" @showDialog="showPartner"></headtip>
                    </div>
                    <div @click="changeheadVisable">
                        <kefu @toptop="topTop"></kefu>
                        <!--            <div class="screen1">-->
                        <!--              &lt;!&ndash;      logo  you气通GPT社区 合作伙伴  登录&ndash;&gt;-->

                        <!--              &lt;!&ndash;       油气通GPT 全球油气行业最专业的、开放的大模型人工智能云平台&ndash;&gt;-->
                        <!--              <div class="layer2">-->
                        <!--                <div v-sliden-instep="{duration:800}"  class="title1"><img loading="lazy" src="@/assets/AnxunLogo.png"></div>-->
                        <!--                <div v-sliden-instep="{duration:1600}" class="title11" style="font-weight: bolder;" >智慧油气基础设施建设</div>-->
                        <!--                <div v-sliden-instep="{duration:2400}" class="title2" style="font-weight: bolder;">全方位系统集成和全球化运维支持，打造高效、安全、高度协同的智慧油田生态系统</div>-->
                        <!--                <div v-sliden-instep="{duration:3000}" class="title4" style="font-weight: bolder;">油气数智，简单易行</div>-->
                        <!--                <div  class="titlle3" @click="clickConsult('油气通')" style="font-weight: bolder;">-->
                        <!--                  产品咨询-->
                        <!--                </div>-->
                        <!--              </div>-->
                        <!--              &lt;!&ndash;      平台大图&ndash;&gt;-->
                        <!--              <div class="layer3"></div>-->
                        <!--            </div>-->
                        <Anxunheader :title1="'智慧新能源'"
                            :title2="'面向油气井场、场站及营地供电需求，通过构建“光伏 + 储能 + 智能控制”的一体化新能源供电系统，实现能源调度优化、设备运行监控与智能运维管理，减少柴油发电依赖，降低能源成本与运维成本，提升油气生产的能源保障能力。'"
                            @clickConsult1="clickConsult('油气通')"></Anxunheader>
                        <!--            <div class="screenmake0">-->
                        <!--              <div class="heighLight">-->

                        <!--                智慧油气基础设施建设</div>-->
                        <!--              <div class="heightLight2" style="font-weight: bold">智慧油气基础设施建设通过整合先进技术与自主研发产品，<span style=" color: #FF6400;">提供全方位系统集成和全球化运维支持，助力油气行业实现高效、安全、可持续发展</span>。</div>-->
                        <!--            </div>-->
                        <!--            您的收益-->
                        <div class="screenmake111" style="background-color: white">
                            <div v-sliden-in="{ duration: 800 }" class="heighLight">您的收益</div>
                            <div class="grid1" style="height: 37vh">
                                <image-up-text-down v-sliden-in="{ duration: 800 + 400 * index }"
                                    v-for="(elemnt, index) in yourBenfits" :key="elemnt.title1"
                                    :imagepath="require('@/assets' + elemnt.imagepath)" :title1="elemnt.title1"
                                    :title2="elemnt.title2"></image-up-text-down>
                            </div>
                        </div>
                        <div class="screenmake3" style="padding-top: 5vh">
                            <div v-sliden-instep="{ duration: 3000 }" class="heighLight">业务痛点与挑战</div>
                            <!--              <div class="line"></div>-->
                            <div v-sliden-instep="{ duration: 3000 }" class="grid">
                                <div v-for="(item, index) in businessPainPoints" :key="index" class="card">
                                    <div class="back">
                                        <div class="imgDesign" style="margin:0 auto">
                                            <img loading="lazy" style="border-radius: 50%"
                                                :src="require('@/assets' + item.imagepath)">
                                        </div>
                                        <div class="titleDesign">
                                            <div class="title1">{{ item.title1 }}</div>
                                            <div class="title2">{{ item.title2 }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="screenmake2" style="background-color: transparent">
                            <div v-sliden-in="{ duration: 800 }" class="heighLight">
                                核心价值</div>
                            <div v-sliden-in="{ duration: 800 }" class="grid">
                                <div v-for="(item, index) in coreFeatures" :key="index" class="card">
                                    <div :class="index === 0 ? 'back' : index < 4 ? 'back' + index : 'back'">
                                        <div class="titleDesign">
                                            <div class="title1">{{ item.title1 }}</div>
                                            <div class="title2">
                                                <li v-for="(line, i) in item.title2Items" :key="i">{{ line }}</li>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div class="screenmake6" style="background-color: #fff">
                            <div v-sliden-in="{ duration: 800 }" class="heighLight"> 技术特色</div>
                            <div v-sliden-in="{ duration: 800 }" class="grid">
                                <div v-for="(item, index) in technicalFeatures" :key="index" class="card">
                                    <div class="back">
                                        <div class="imgDesign" :style="index === 0 ? { width: '12vh' } : {}">
                                            <img loading="lazy" :src="require('@/assets/' + item.imagepath)"
                                                style="border-radius: 9px">
                                        </div>
                                        <div class="titleDesign">
                                            <div class="title1">{{ item.title1 }}</div>
                                            <div class="title2">{{ item.title2 }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="screenmake3" style="background-color: transparent;">
                            <div v-sliden-in="{duration:800}" class="heighLight"> 服务能力</div>
                            <div v-sliden-in="{duration:800}" class="grid">
                                <div class="card" v-for="(item, index) in serviceCapabilities" :key="index">
                                <div class="back" style="background-color: white">
                                    <div class="imgDesign" style="width: 100%;height: 30vh">
                                    <img loading="lazy"  style="border-top-right-radius: 9px;border-top-left-radius: 9px" :src="item.img">

                                    </div>
                                    <div class="titleDesign" style="padding-bottom: 2vh">
                                    <div class="title1">{{ item.title1 }}
                                    </div>
                                    <div class="title2">
                                        <li  v-for="(line, i) in item.title2Items" :key="i">{{ line }}</li>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>

                        </div>

                        <div class="screenmake4">
                            <div v-sliden-in="{ duration: 800 }" class="heighLight">成功案例</div>
                            <div class="grid">
                                <el-carousel indicator-position="outside" arrow="always" interval="5000">
                                    <el-carousel-item v-for="item in success" :key="item">
                                        <div class="card">
                                            <div class="back">
                                                <div v-left-in="{ duration: 800 }" class="imgDesign">
                                                    <el-tooltip class="item" effect="dark" content="点击放大，看得更清晰！"
                                                        placement="top">
                                                        <img loading="lazy" @click="showModalTrue(item.img)"
                                                            :src="item.img" />

                                                    </el-tooltip>
                                                </div>
                                                <div v-sliden-in="{ duration: 800 }" class="titleDesign">
                                                    <div class="title1">{{ item.title1 }}</div>
                                                    <div class="title2" v-html="item.title2"></div>
                                                </div>
                                            </div>


                                        </div>


                                    </el-carousel-item>
                                </el-carousel>
                            </div>

                        </div>
                        <bottomTip></bottomTip>
                    </div>
                </div>
                <div v-if="showModal" @click="closeModal" class="modal-overlay">
                    <div class="modal-content">
                        <img :src="largeSrc" alt="Large Image" class="large-image">
                    </div>
                </div>
                <partnerTip :dialogVisible="dialogconsult" @hideDialog="hide"></partnerTip>
                <consultTip :dialogVisible="dialogVisible" :thisTitle="title" @hideDialog="hideDialog"></consultTip>
            </div>
        </div>
        <div v-else>
            <div class="totalmakeHoleModel" ref="totalModel">
                <div class="makeHole1">
                    <div class="screen1">
                        <kefuMobile @topMobile="topTopmobile"></kefuMobile>
                        <headtip @showDialog="showPartner"></headtip>

                        <div class="layer2">
                            <div v-sliden-instep="{ duration: 800 }" class="title1"><img loading="lazy"
                                    src="@/assets/AnxunLogo.png"></div>
                            <div v-sliden-instep="{ duration: 1600 }" class="title2"
                                style="font-weight: bolder;font-size: 25px;margin-top: 15px;line-height: 30px;color:#F44336">
                                智慧新能源
                            </div>
                            <div v-sliden-instep="{ duration: 1600 }" class="title2"
                                style="font-weight: bolder;margin-top: 15px;font-size: 18px;line-height: 28px;color:#2c3e50;text-align: left">
                                面向油气井场、场站及营地供电需求，通过构建“光伏 + 储能 +
                                智能控制”的一体化新能源供电系统，实现能源调度优化、设备运行监控与智能运维管理，减少柴油发电依赖，降低能源成本与运维成本，提升油气生产的能源保障能力。</div>
                            <!--              <div v-sliden-instep="{duration:2400}" class="title4" style="font-weight: bolder;font-size: 18px;line-height: 28px;">油气数智，简单易行</div>-->

                        </div>
                        <div style="position: absolute;bottom: 30px;left: 50%;transform:translateX(-50%);">
                            <div v-sliden-instep="{ duration: 2400 }" class="title4"
                                style="font-weight: bolder;font-size: 18px;line-height: 28px;padding-bottom: 5px;color: #2f6dfd;">
                                油气数智，简单易行</div>
                            <div class="titlle3" @click="clickConsult('油气通')">
                                产品咨询
                            </div>
                        </div>
                        <!--      平台大图-->
                        <div class="layer3"></div>
                    </div>
                    <!--          <div class="screenmake0">-->
                    <!--            <div v-sliden-in="{duration:800}" class="heighLight">-->

                    <!--              智慧油气基础设施建设</div>-->
                    <!--            <div v-sliden-in="{duration:800}" class="heightLight2" style="font-weight: bold">智慧油气基础设施建设通过整合先进技术与自主研发产品，<span style=" color: #FF6400;">提供全方位系统集成和全球化运维支持，助力油气行业实现高效、安全、可持续发展</span>。</div>-->
                    <!--          </div>-->
                    <div class="screenmake111">
                        <div v-sliden-in="{ duration: 800 }" class="heighLight">您的收益</div>
                        <div class="grid" style="height: 650px">
                            <image-up-text-down-mobile v-for="elemnt in yourBenfits" :key="elemnt.title1"
                                :imagepath="require('@/assets' + elemnt.imagepath)" :title1="elemnt.title1"
                                :title2="elemnt.title2"></image-up-text-down-mobile>
                        </div>
                    </div>
                    <div class="screenmake3" style="padding-top: 15px">
                        <div v-sliden-in="{ duration: 800 }" class="heighLight"> 业务痛点与挑战</div>
                        <div class="grid">
                            <div v-for="(item, index) in businessPainPoints" :key="index"
                                v-sliden-in="{ duration: 800 }" class="card"
                                :style="index === 0 ? 'margin-top: 10px' : ''">
                                <div class="back">
                                    <div class="imgDesign">
                                        <img loading="lazy" src="@/assets/basic01.jpg"
                                            style="border-top-left-radius: 9px;border-top-right-radius: 9px">
                                    </div>
                                    <div class="titleDesign">
                                        <div class="title1">{{ item.title1 }}</div>
                                        <div class="title2">{{ item.title2 }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="screenmake6">
                        <div v-sliden-in="{ duration: 800 }" class="heighLight"> 技术特色</div>
                        <div class="grid">
                            <div v-for="(item, index) in technicalFeatures" :key="index" v-sliden-in="{ duration: 800 }"
                                class="card">
                                <div class="back">
                                    <div class="imgDesign">
                                        <img loading="lazy" :src="require('@/assets/' + item.imagepath)"
                                            style="border-radius: 9px;height: 40px;margin-top: 2.5px">
                                    </div>
                                    <div class="titleDesign">
                                        <div class="title1">{{ item.title1 }}</div>
                                        <div class="title2">{{ item.title2 }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="screenmake3" style="background-color: transparent;padding-top: 20px;">
                            <div v-sliden-in="{duration:800}" class="heighLight"> 服务能力</div>
                            <div v-sliden-in="{duration:800}" class="grid">
                                <div class="card" v-for="(item, index) in serviceCapabilities" :key="index">
                                <div class="back" style="background-color: white">
                                    <div class="imgDesign" style="width: 100%;height: 30vh">
                                    <img loading="lazy"  style="border-top-right-radius: 9px;border-top-left-radius: 9px" :src="item.img">

                                    </div>
                                    <div class="titleDesign" style="padding-bottom: 2vh">
                                    <div class="title1">{{ item.title1 }}
                                    </div>
                                    <div class="title2">
                                        <li  v-for="(line, i) in item.title2Items" :key="i">{{ line }}</li>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>

                        </div>

                    <!-- <div class="screenmake0" style="background-color: #fff">
                        <div v-sliden-in="{ duration: 800 }" class="heighLight" style="margin-top:0">服务能力</div>
                        <div v-sliden-in="{ duration: 800 }" class="grid grid--serviceCapability">
                            <div class="card">
                                <div class="back" style="background-color: transparent">
                                    <div class="imgDesign">
                                        <el-tooltip class="item" effect="dark" content="点击放大，看得更清晰！" placement="top">
                                            <img loading="lazy" @click="showModalTrue(require('@/assets/anxun11.jpg'))"
                                                style="border-top-left-radius: 9px;border-bottom-left-radius: 9px"
                                                src="@/assets/anxun11.jpg">
                                        </el-tooltip>
                                    </div>
                                    <div class="titleDesign serviceCapabilityList">
                                        <div v-for="(item, index) in serviceCapabilities" :key="index"
                                            class="capability-item">
                                            <div class="capability-title" style="font-weight: bold;margin-top: 10px;">{{
                                                item.title1 }}</div>
                                            <div class="capability-desc">
                                                <div v-for="(line, i) in item.title2Items" :key="i"
                                                    class="capability-line">{{ line }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div> -->
                    <div class="screenmake4">
                        <div v-sliden-in="{ duration: 800 }" class="heighLight">成功案例</div>
                        <div v-sliden-in="{ duration: 800 }" class="grid">
                            <el-carousel indicator-position="outside" arrow="always" interval="5000">
                                <el-carousel-item v-for="item in success" :key="item">
                                    <div class="card">
                                        <div class="back">
                                            <div class="imgDesign">
                                                <img loading="lazy" :src="item.img" />
                                            </div>
                                            <div class="titleDesign">
                                                <div class="title1">{{ item.title1 }}</div>
                                                <div class="title2" v-html="item.title2"></div>
                                            </div>
                                        </div>


                                    </div>


                                </el-carousel-item>
                            </el-carousel>
                        </div>

                    </div>
                    <div ref="bottom">
                        <bottomTip></bottomTip>
                    </div>

                </div>
                <partnerTip :dialogVisible="dialogconsult" @hideDialog="hide"></partnerTip>
                <consultTip :dialogVisible="dialogVisible" :thisTitle="title" @hideDialog="hideDialog"></consultTip>
            </div>
        </div>
    </div>
</template>
<script>

import consultTip from "@/components/consultTip.vue";
import PartnerTip from "@/components/partnerTip.vue";
import { vLeftIn } from "@/utils/vLeftIn";
import { vSlidenIn } from "@/utils/vSlidenIn";
import { vSlidenInstep } from "@/utils/vSlidenInstep";
import { shareUrl } from "@/utils/vxshare";
import { vZoomIn } from "@/utils/vZoomIn";
import Anxunheader from "@/views/Anxun/components/Anxunheader.vue";
import bottomTip from "@/views/bottomTip.vue";
import imageUpTextDown from "@/views/components/imageUpTextDown.vue";
import ImageUpTextDownMobile from "@/views/components/imageUpTextDownMobile.vue";
import headtip from "@/views/headTip.vue";
import kefu from "@/views/kefu.vue";
import kefuMobile from "@/views/kefuMobile.vue";
export default {
    directives: {
        slidenIn: vSlidenIn,
        zoomIn: vZoomIn,
        slidenInstep: vSlidenInstep,
        leftIn: vLeftIn
    },

    name: "",

    props: [],

    components: {
        ImageUpTextDownMobile,
        imageUpTextDown, Anxunheader, PartnerTip, consultTip, headtip, bottomTip, kefu, kefuMobile
    },

    data() {
        return {
            yourBenfits: [
                {
                    imagepath: '/storagebenefit2.png',
                    title1: '增强管网可视性与安全保障',
                    title2: '全面数字化监管与可视化管理使用户实时掌握管网运行状态，快速应对突发事件，显著提升安全性。'
                },
                {
                    imagepath: '/stationbenefit2.png',
                    title1: '优化资源利用与降低运维成本',
                    title2: '智能调度与自动化管理提高资源利用效率，减少人为错误和数据孤岛带来的浪费，从而降低运维成本。'
                },
                {
                    imagepath: '/stationbenefit3.png',
                    title1: '提升决策支持与管理效能',
                    title2: '数据驱动的分析与预测为管理层提供智慧调度决策支持，帮助制定科学的运营策略，提升管理效能。'
                },
                {
                    imagepath: '/stationbenefit4.png',
                    title1: '助力管网管理智慧化转型',
                    title2: '助力企业从传统管理向智慧化转型，实现管网管理的数字化、智能化和精细化，满足未来需求。'
                },
            ],
            businessPainPoints: [
                { imagepath: '/station01.png', title1: '偏远油气区供电成本高', title2: '油气井场多位于偏远地区，依赖柴油发电，燃料运输与维护成本高。' },
                { imagepath: '/station02.png', title1: '供电稳定性不足', title2: '传统柴油发电机组稳定性有限，容易影响生产运行。' },
                { imagepath: '/station03.png', title1: '新能源设备管理困难', title2: '光伏、电池、逆变器等设备数量多，缺乏统一监控与管理平台。' },
                { imagepath: '/station04.png', title1: '运维成本持续上升', title2: '新能源设备巡检与维护依赖人工，管理效率低。' },
            ],
            coreFeatures: [
                { title1: '新能源供电管理平台', title2Items: ['实现光伏发电与储能系统统一管理', '实时监控电站运行状态', '实现能源运行数据可视化'] },
                { title1: '储能调度与能源优化', title2Items: ['实现储能系统智能调度', '优化能源使用效率', '提高供电稳定性'] },
                { title1: '设备监测与智能运维', title2Items: ['实现设备运行状态监测', '提供故障预警与报警管理', '支持远程运维管理'] },
                { title1: '无人巡检系统', title2Items: ['支持无人机巡检光伏电站', '自动识别设备异常', '提高巡检效率'] },
            ],
            serviceCapabilities: [
                { title1: '新能源供电系统建设', img: require('@/assets/Visualization5.png'), title2Items: ['光伏电站建设', '储能系统部署', '新能源供电系统集成'] },
                { title1: '新能源平台建设', img: require('@/assets/knowledgenew2.png'), title2Items: ['新能源监控平台建设', '综合能源管理系统建设', '电站数据管理系统建设'] },
                { title1: '系统集成与实施', img: require('@/assets/equipment5new.png'), title2Items: ['集成新能源设备与控制系统', '建设能源监控网络', '实现多系统协同运行'] },
                { title1: '运维与技术支持', img: require('@/assets/zhushihua.jpg'), title2Items: ['提供新能源系统运维服务', '提供系统优化与升级', '提供技术培训与支持'] },
            ],
            technicalFeatures: [
                { title1: '综合能源管理平台', title2: '通过统一能源管理平台，实现新能源系统运行数据的集中监控与管理。', imagepath: 'guanwang1.png' },
                { title1: '能源调度与优化算法', title2: '通过智能算法优化储能调度与能源使用，提高能源利用效率。', imagepath: 'guanwang2.png' },
                { title1: '工业物联网技术', title2: '通过物联网技术实现光伏设备、储能系统与管理平台的实时连接。', imagepath: 'guanwang3.png' },
                { title1: '数字孪生电站技术', title2: '构建新能源电站数字孪生模型，实现设备运行状态可视化管理。', imagepath: 'guanwang4.png' },
            ],
            changeVisable: 1,
            showModal: false,
            largeSrc: '',
            title: '',
            pageTitle: '智慧油气基础设施建设_安迅数智-油气通GPT',
            pageDescription: '安迅数智智慧油气基础设施建设，提供设施建设、自主软硬件产品、系统集成与实施、维护与运维服务，提供一系列自主开发的软硬件产品，包括PLC、RTU、DCS、SIS、FGS、SCADA等。',
            pageKeywords: '智慧油气，基础设施建设，智慧油气基础设施建设，井口一体化远传系统，远程调压解决方案，橇装机柜间整体解决方案，数字化抽油机控制柜，安迅智云，语音机器人助理，安迅数智，油气通GPT',
            model: false,
            scrollback: false,
            dialogconsult: false,
            dialogVisible: false,
            success: [{
                img: require("@/assets/ax-success/newenergy1.png"),
                title1: "NT湾区科创城光伏电站",
                title2: "某园区新能源供电场景，构建光伏发电监测与运维管理系统，实现发电设备运行状态监测与能效分析；基于物联网感知与数据平台技术，提升发电效率与运维管理水平。",
            },{
                img: require("@/assets/ax-success/newenergy2.png"),
                title1: "伊拉克E油田光储一体化能源管理平台",
                title2: "E油田绿色能源转型，构建光伏+储能一体化能源管理平台，实现发电、储能与用能的协同调度；通过能量管理系统（EMS）、数据分析与优化控制技术，提升能源利用效率与供能稳定性。",
            },
            ]
        }

    },

    methods: {
        topTopmobile() {
            console.log("fuzujianchuanzhi")
            //const element = this.$refs.total;
            //const rect = element.offsetTop + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
            this.$nextTick(() => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        },
        topTop() {
            console.log("fuzujianchuanzhi")
            //const element = this.$refs.total;
            //const rect = element.offsetTop + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
            this.$nextTick(() => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        },

        changeheadVisable() {
            if (this.changeVisable === 1) {
                this.changeVisable = 0
            }
            else {
                this.changeVisable = 1
            }
            console.log("父组件", this.changeVisable)
        },
        showModalTrue(item) {
            this.showModal = true;
            console.log(item)
            this.largeSrc = item
        },
        closeModal() {
            this.showModal = false;
        },
        clickConsult(item) {

            this.title = item
            this.dialogVisible = true;
            sessionStorage.setItem('title', item)
        },
        hide() {
            this.dialogconsult = false;
        },
        hideDialog() {
            this.dialogVisible = false;
        },
        showPartner() {
            this.dialogconsult = true;
        },
        skipp3() {
            const element = this.$refs.bottom;
            const rect = element.offsetTop + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);

            this.$nextTick(() => {
                this.$refs.totalModel.scrollTop = rect
            });
        }, setMetaTags() {
            const metaDescription = document.querySelector('meta[name="description"]');
            if (metaDescription) {
                metaDescription.setAttribute('content', this.pageDescription);
            }

            const metaKeywords = document.querySelector('meta[name="keywords"]');
            if (metaKeywords) {
                metaKeywords.setAttribute('content', this.pageKeywords);
            }
        },
        handleScroll() {
            if (this.model === false) {
                this.scrollHeight = this.$refs.total.scrollTop;
            }
            else {
                this.scrollHeight = this.$refs.totalModel.scrollTop;
            }

            if (this.scrollHeight < 100) {
                this.scrollTrue = true
            }
            else {
                this.scrollTrue = false
            }
            if (this.scrollHeight < 50) {
                this.scrollback = false
            }
            else {
                this.scrollback = true
            }
            console.log("gaodu", this.scrollHeight < 100)
        },
    },
    beforeDestroy() {

        this.$refs.total.removeEventListener('scroll', this.handleScroll);
    },
    mounted() {
        this.$refs.total.addEventListener('scroll', this.handleScroll);
        document.title = this.pageTitle;
        this.setMetaTags();
        const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        // Log the values1731 809   1653 834   1912 932
        console.log("Screen Width: ", screenWidth);
        console.log("Screen Height: ", screenHeight);
        if (screenWidth <= 700) {
            this.model = true
        } else {
            this.model = false
        }

        if (localStorage.getItem("skip") === '3') {
            this.$nextTick(() => {
                this.skipp3();
            });
        }
    },
    created() {
        localStorage.setItem("home", 0)
        let url = window.location.href
        // let url = 'https://oilgasinfoai.com/?language=zh'
        setTimeout(() => {
            //encodeURIComponent 将你的URL进行转译一下，因为微信分享出去后会带有多余用不到的参数
            let shareData = {
                url: url,
                pageTitle: '智慧油气基础设施建设_安迅数智-油气通GPT',
                pageDescription: '安迅数智智慧油气基础设施建设，提供设施建设、自主软硬件产品、系统集成与实施、维护与运维服务，提供一系列自主开发的软硬件产品，包括PLC、RTU、DCS、SIS、FGS、SCADA等。',
                pageKeywords: '智慧油气，基础设施建设，智慧油气基础设施建设，井口一体化远传系统，远程调压解决方案，橇装机柜间整体解决方案，数字化抽油机控制柜，安迅智云，语音机器人助理，安迅数智，油气通GPT',

            };
            shareUrl(shareData);
        }, 1000);
    },
}

</script>


<style type="text/scss" lang="scss" scoped>
.totalmakeHole {
    background: #ebf1fd;
    overflow-x: hidden;
    // width: 100vw;
    height: auto;
    position: relative;

    .makeHole1 {
        //z-index:: 3;
        position: relative;
        width: 100%;

        //height: 100vh;
        .topback {
            position: fixed;
            z-index: 999;
            width: 100vw;
            padding: 0 0 0 2.86077411900635vw;
        }

        //.screen1 {
        //  ////z-index::: 3;
        //  position: relative;
        //  width: 100%;
        //  height: 74vh;
        //  padding: 2.84301606922126vh 2.86077411900635vw  2.84301606922126vh 2.86077411900635vw;
        //  background-image: url("../../assets/banner.png");
        //  background-position: center;
        //  background-size: cover;
        //  background-repeat: no-repeat;
        //  background-color: transparent;
        //  /* Add any additional styling as needed */
        //
        //  .layer2 {
        //    position: absolute;
        //    top: 18.1495673671199vh;
        //    left: 9.17157712305026vw;
        //    .title11{
        //      margin: 3.8207663782vh auto 3.0207663782vh auto ;
        //      font-size: 2vw;
        //
        //    }
        //    .title1 {
        //      width: fit-content;
        //      height: 5.77626699629172vh;
        //      //font-size: 3.50606585788562vw;
        //      font-family: Sarial, sans-serif, "Microsoft Yahei";
        //      font-weight: 400;
        //      color: #2f6eff;
        //      //line-height: 12.23733003708282vh;
        //    }
        //
        //    .title2 {
        //      //margin-top: 6.82076637824475vh;
        //      width: 33.45869439630272vw;
        //      height: fit-content;
        //      font-size: 1.0597920277vw;
        //      font-family: Sarial, sans-serif, "Microsoft Yahei";
        //      font-weight: 400;
        //      color: black;
        //      line-height: 4.31520395550062vh;
        //    }
        //    .title4{
        //      height: 8.77626699629172vh;
        //      font-size: 1.6060658579vw;
        //      font-family: Sarial, sans-serif, "Microsoft Yahei";
        //      font-weight: 400;
        //      color: #2f6eff;
        //      line-height: 9.31520395550062vh;
        //    }
        //    .titlle3{
        //      margin-top: 2.07911001236094vh;
        //      cursor: pointer;
        //      display: flex;
        //      justify-content: center;
        //      align-items: center;
        //      font-size: 1vw;
        //      font-family: Sarial, sans-serif, "Microsoft Yahei";
        //      font-weight: 400;
        //      color: #ffffff;
        //      line-height: 3.3374536465vh;
        //      text-align: center;
        //      border-radius: 9.1px;
        //      width: fit-content;
        //      padding: 2.4624227441vh 1.1989601386vw;
        //      height: 4.5624227441vh;
        //      background: #2f6eff;
        //      border: #2f6eff 1px solid;
        //
        //    }
        //    .titlle3:hover{
        //
        //      color: #2168DB;
        //      border: #2168DB 1px solid;
        //      background: rgba(255, 255, 255, 0.5);
        //    }
        //  }
        //
        //
        //  //.layer3 {
        //  //  position: absolute;
        //  //  top: 5.06798516687268vh;
        //  //  right: 11.61178509532062vw;
        //  //  width: 47.42923165800116vw;
        //  //  height: 72.80593325092707vh;
        //  //  background-image: url("../assets/GPTplant.png");
        //  //  background-size: 100% auto;
        //  //  background-position: center;
        //  //  background-repeat: no-repeat;
        //  //  background-color: transparent;
        //  //  opacity: 1;
        //  //}
        //}
        .screenmake111 {
            padding: 5.78739184177998vh 8.09763142692085vw;
            width: 100%;
            height: fit-content;
            background: white;

            .heighLight {
                margin: 0 auto;
                text-align: center;
                height: 8.23733003708282vh;
                opacity: 1;
                font-weight: bold;
                font-size: 2.2060658579vw;
                //color: #53A3F7;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                line-height: 4.23733003708282vh;

            }

            .heightLight2 {
                margin: 0 0.5vw;
                text-align: left;
                height: fit-content;
                font-weight: 400;
                color: #2C3E50;
                line-height: 4.94437577255871vh;
                font-size: 1.15vw;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
            }

            .heightLight3 {
                margin: 3vh auto;
                text-align: center;
                height: fit-content;
                font-weight: bold;
                color: #2C3E50;
                line-height: 4.94437577255871vh;
                font-size: 1.5vw;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
            }

            .grid {
                margin-top: 2.78739184177998vh;
                position: relative;

                .card {
                    //cursor: pointer;
                    width: 100%;
                    height: fit-content;
                    padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
                    opacity: 1;

                    .back {
                        background: white;
                        border-radius: 9px;
                        display: flex;
                        position: relative;
                        //box-shadow: 2px 0 12px 0px #c9d9f5;
                        height: 75vh;
                        overflow: hidden;

                        .imgDesign {
                            width: fit-content;
                            height: 100%;
                            opacity: 1;
                            //background-image: url("../../assets/menage6.png");
                            background-position: center;
                            background-size: cover;
                            background-repeat: no-repeat;
                            background-color: transparent;
                        }

                        .titleDesign {
                            padding: 1.5248454883vh 1.5248454883vw 2.5248454883vh 1.5248454883vw;
                            margin: auto 1vw auto auto;
                            color: black;
                            width: 50%;
                            float: right;

                            .title1 {
                                margin-top: 4vh;
                                font-size: 1.1709416522vw;
                                font-weight: bold;
                            }

                            .title2 {
                                line-height: 3.3vh;
                                font-size: 0.9vw;
                            }
                        }
                    }
                }

                ::v-deep .el-carousel__container {
                    height: 65.87268232385661vh !important;
                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__container {
                    position: relative;
                    height: 48.83559950556242vh;
                }

                ::v-deep .el-carousel__arrow {
                    display: none;
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    //cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    //background: #2168DB;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    //z-index:: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 12px;
                }
            }

            .grid1 {
                margin-top: 2.78739184177998vh;
                position: relative;
                display: grid;
                grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);



                ::v-deep .el-carousel__container {
                    height: 65.87268232385661vh !important;
                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__container {
                    position: relative;
                    height: 48.83559950556242vh;
                }

                ::v-deep .el-carousel__arrow {
                    display: none;
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    //cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    //background: #2168DB;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    //z-index:: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 12px;
                }
            }
        }

        .screenmake3 {
            padding: 5.78739184177998vh 8.09763142692085vw;
            width: 100%;
            height: fit-content;
            background: white;
            position: relative;

            .heighLight {
                margin: 0 auto;
                font-weight: bold;
                text-align: center;
                height: 8.23733003708282vh;
                opacity: 1;
                font-size: 2.2060658579vw;
                //color: #53A3F7;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                line-height: 4.23733003708282vh;

            }

            .heightLight2 {
                margin: 0 auto;
                text-align: center;
                height: 13.78739184177998vh;
                font-weight: 400;
                color: #2C3E50;
                line-height: 4.94437577255871vh;

                width: 60.9693818602vw;
                font-size: 1.0287117273vw;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
            }

            .line {
                height: 1vh;
                width: 82%;
                left: 50%;
                transform: translateX(-50%);
                border-bottom: dashed black 1px;
                position: absolute;
                top: 12.8vh;
                z-index: 1;

            }

            .grid {
                z-index: 2;
                margin-top: 0vh;
                position: relative;
                display: grid;
                grid-template-columns: repeat(4, minmax(0, 1fr));
                column-gap: 2vw;

                .card {
                    //cursor: pointer;
                    width: 100%;
                    height: 100%;
                    padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
                    opacity: 1;

                    .back {
                        width: 100%;
                        //background: #c9d9f5;
                        border-radius: 9px;
                        position: relative;
                        //border: white 1px solid;
                        //box-shadow: 2px 0 12px 0px #c9d9f5;
                        height: 100%;
                        overflow: hidden;

                        .imgDesign {
                            width: 4vh;
                            height: 4vh;
                            background-color: white;
                            opacity: 1;
                        }

                        .titleDesign {
                            padding: 0;
                            margin: 2vh auto 0 auto;
                            color: black;
                            width: 100%;
                            float: right;

                            .title1 {
                                margin: 0 auto;
                                text-align: center;
                                font-size: 1.1709416522vw;
                                font-weight: bold;
                            }

                            .title2 {
                                margin: 2vh auto 0 auto;
                                width: fit-content;
                                line-height: 3.194066749vh;
                                font-size: 0.9vw;
                            }

                            .title3 {
                                display: grid;
                                grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

                                margin-top: 2vh;
                                line-height: 3.194066749vh;
                                font-size: 0.8243212016vw;
                            }

                        }

                    }
                }

                ::v-deep .el-carousel__container {
                    height: 65.87268232385661vh !important;
                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__container {
                    position: relative;
                    height: 48.83559950556242vh;
                }

                ::v-deep .el-carousel__arrow {
                    display: none;
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    //cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    //background: #2168DB;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    //z-index:: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 12px;
                }
            }
        }

        .screenmake2 {
            padding: 5.78739184177998vh 8.09763142692085vw 5.78739184177998vh 8.09763142692085vw;
            width: 100%;
            height: fit-content;
            background: white;

            .heighLight {
                margin: 0 auto;
                font-weight: bold;
                text-align: center;
                height: 8.23733003708282vh;
                opacity: 1;
                font-size: 2.2060658579vw;
                //color: #53A3F7;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                line-height: 4.23733003708282vh;

            }

            .heightLight2 {
                margin: 0 auto;
                text-align: center;
                height: 13.78739184177998vh;
                font-weight: 400;
                color: #2C3E50;
                line-height: 4.94437577255871vh;

                width: 60.9693818602vw;
                font-size: 1.0287117273vw;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
            }

            .grid {
                margin-top: 2.78739184177998vh;
                position: relative;
                display: grid;
                grid-template-columns: repeat(4, minmax(0, 1fr));
                column-gap: 1.5vw;

                .card {
                    //cursor: pointer;
                    width: 100%;
                    height: fit-content;
                    padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
                    opacity: 1;

                    .titleDesign {
                        z-index: 999;
                        padding: 0;
                        margin: 0 0 0 1.5vw;
                        color: black;
                        width: 100%;
                        float: right;

                        .title1 {
                            margin: 0 auto;
                            text-align: center;
                            font-size: 1.1709416522vw;
                            font-weight: bold;
                        }

                        .title2 {
                            z-index: 999;
                            margin-top: 2vh;
                            text-align: justify;
                            line-height: 3.194066749vh;
                            font-size: 0.9vw;
                        }

                        .title3 {
                            display: grid;
                            grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

                            margin-top: 2vh;
                            line-height: 3.194066749vh;
                            font-size: 0.8243212016vw;
                        }

                    }

                    .back {
                        border-radius: 9px;
                        //display: flex;
                        position: relative;
                        border: 1px solid white;
                        box-shadow: 2px 0 12px 0px #c9d9f5;
                        background-image: url("../../assets/equipmentBack.png");
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat;
                        background-color: transparent;
                        height: 38vh;
                        padding: 2vh 1.5vw 3vh 1.5vw;
                        overflow: hidden;


                    }

                    .back1 {
                        border-radius: 9px;
                        //display: flex;
                        position: relative;
                        border: 1px solid white;
                        box-shadow: 2px 0 12px 0px #c9d9f5;
                        background-image: url("../../assets/equipmentBack.png");
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat;
                        background-color: transparent;
                        height: 38vh;
                        padding: 2vh 1.5vw 3vh 1.5vw;
                        overflow: hidden;


                    }

                    .back2 {
                        border-radius: 9px;
                        //display: flex;
                        position: relative;
                        border: 1px solid white;
                        box-shadow: 2px 0 12px 0px #c9d9f5;
                        background-image: url("../../assets/equipmentBack.png");
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat;
                        background-color: transparent;
                        height: 38vh;
                        padding: 2vh 1.5vw 3vh 1.5vw;
                        overflow: hidden;


                    }

                    .back3 {
                        border-radius: 9px;
                        //display: flex;
                        position: relative;
                        border: 1px solid white;
                        box-shadow: 2px 0 12px 0px #c9d9f5;
                        background-image: url("../../assets/equipmentBack.png");
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat;
                        background-color: transparent;
                        height: 38vh;
                        padding: 2vh 1.5vw 3vh 1.5vw;
                        overflow: hidden;


                    }
                }

                ::v-deep .el-carousel__container {
                    height: 65.87268232385661vh !important;
                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__container {
                    position: relative;
                    height: 48.83559950556242vh;
                }

                ::v-deep .el-carousel__arrow {
                    display: none;
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    //cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    //background: #2168DB;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    //z-index:: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 12px;
                }
            }
        }


        .screenmake6 {
            padding: 5.78739184177998vh 8.09763142692085vw 4.78739184177998vh 8.09763142692085vw;
            width: 100%;
            height: fit-content;
            //background: transparent;
            background: white;

            .heighLight {
                margin: 0 auto;
                font-weight: bold;
                text-align: center;
                height: 8.23733003708282vh;
                opacity: 1;
                font-size: 2.2060658579vw;
                //color: #53A3F7;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                line-height: 4.23733003708282vh;

            }

            .heightLight2 {
                margin: 0 auto;
                text-align: center;
                height: 13.78739184177998vh;
                font-weight: 400;
                color: #2C3E50;
                line-height: 4.94437577255871vh;
                width: 60.9693818602vw;
                font-size: 1.0287117273vw;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
            }

            .grid {
                margin-top: 2.78739184177998vh;
                position: relative;
                display: grid;
                grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
                column-gap: 0;

                .card {
                    //cursor: pointer;
                    width: 100%;
                    height: fit-content;
                    padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
                    opacity: 1;

                    .back {
                        border-radius: 9px;
                        background: white;
                        //display: flex;
                        position: relative;
                        box-shadow: 2px 0 12px 0px #c9d9f5;
                        height: 39vh;
                        overflow: hidden;

                        .imgDesign {
                            width: 8vh;
                            height: 8vh;
                            opacity: 1;
                            margin: 3vh auto;
                            //background-image: url("../../assets/menage6.png");
                        }

                        .titleDesign {
                            padding: 0;
                            margin: 0 0 0 1.5vw;
                            color: black;
                            width: 85%;

                            //float: right;
                            .title1 {
                                text-align: center;
                                margin-top: 0;
                                font-size: 1.1709416522vw;
                                font-weight: bold;
                            }

                            .title2 {
                                margin-top: 2vh;
                                text-align: justify;
                                line-height: 3.194066749vh;
                                font-size: 0.9vw;
                            }

                            .title3 {
                                display: grid;
                                grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

                                margin-top: 2vh;
                                line-height: 3.194066749vh;
                                font-size: 0.8243212016vw;
                            }

                        }

                    }
                }

                ::v-deep .el-carousel__container {
                    height: 65.87268232385661vh !important;
                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__container {
                    position: relative;
                    height: 48.83559950556242vh;
                }

                ::v-deep .el-carousel__arrow {
                    display: none;
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    //cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    //background: #2168DB;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    //z-index:: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 12px;
                }
            }
        }

        .screenmake0 {
            padding: 5.78739184177998vh 8.09763142692085vw;
            width: 100%;
            height: fit-content;
            background: white;

            .heighLight {
                margin: 0 auto;
                text-align: center;
                height: 8.23733003708282vh;
                opacity: 1;
                font-weight: bold;
                font-size: 2.2060658579vw;
                //color: #53A3F7;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                line-height: 4.23733003708282vh;

            }

            .heightLight2 {
                margin: 0 auto;
                text-align: center;
                height: fit-content;
                font-weight: 400;
                color: #2C3E50;
                line-height: 4.94437577255871vh;
                font-size: 1.15vw;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
            }

            .heightLight3 {
                margin: 3vh auto;
                text-align: center;
                height: fit-content;
                font-weight: bold;
                color: #2C3E50;
                line-height: 4.94437577255871vh;
                font-size: 1.5vw;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
            }

            .grid--serviceCapability {
                display: grid;
                grid-template-columns: 1fr;
            }

            .serviceCapabilityList {
                list-style: none;
                padding: 0;
                margin: 0;

                .capability-item {
                    margin-bottom: 2vh;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }

                .capability-title {
                    font-weight: bold;
                    margin-bottom: 0.5vh;
                }

                .capability-desc {
                    padding-left: 1.5em;
                }

                .capability-line {
                    line-height: 1.8;
                    list-style: none;
                }
            }

            .grid {
                margin-top: 2.78739184177998vh;
                position: relative;

                .card {
                    //cursor: pointer;
                    width: 100%;
                    height: fit-content;
                    padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
                    opacity: 1;

                    .back {
                        background: #eeeeef;
                        border-radius: 9px;
                        display: flex;
                        position: relative;
                        box-shadow: 2px 0 12px 0px #eeeeef;
                        height: 60vh;
                        overflow: hidden;

                        .imgDesign {
                            width: fit-content;
                            height: 100%;
                            opacity: 1;
                            //background-image: url("../../assets/menage6.png");
                            background-position: center;
                            background-size: cover;
                            background-repeat: no-repeat;
                            background-color: transparent;
                        }

                        .titleDesign {
                            padding: 1.5248454883vh 1.5248454883vw 2.5248454883vh 0;
                            margin: auto 1vw auto auto;
                            color: black;
                            width: 50%;
                            float: right;

                            .title1 {
                                margin-top: 4vh;
                                font-size: 1.1709416522vw;
                                font-weight: bold;
                            }

                            .title2 {
                                line-height: 3.3vh;
                                font-size: 0.9vw;
                            }
                        }
                    }
                }

                ::v-deep .el-carousel__container {
                    height: 65.87268232385661vh !important;
                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__container {
                    position: relative;
                    height: 48.83559950556242vh;
                }

                ::v-deep .el-carousel__arrow {
                    display: none;
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    //cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    //background: #2168DB;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    //z-index:: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 12px;
                }
            }

            .grid1 {
                margin-top: 2.78739184177998vh;
                position: relative;
                display: grid;
                grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

                .card {
                    //cursor: pointer;
                    width: 100%;
                    height: fit-content;
                    padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
                    opacity: 1;

                    .back {
                        background: #ebf1fd;
                        ;
                        border-radius: 9px;
                        position: relative;
                        border: white 3px solid;
                        box-shadow: 2px 0 12px 0px #c9d9f5;
                        height: fit-content;
                        overflow: hidden;

                        .imgDesign {
                            width: 10vh;
                            height: 10vh;
                            margin: 3vh 1vw 5vh 2vw;
                            opacity: 1;
                            background-position: center;
                            background-size: cover;
                            background-repeat: no-repeat;
                            background-color: transparent;
                        }

                        .title1 {
                            margin-top: 4vh;
                            font-size: 1.1709416522vw;
                            font-weight: bold;
                        }

                        .titleDesign {
                            padding: 0 1.5248454883vw 2.5248454883vh 0;
                            margin: 0 auto;
                            color: black;
                            width: 80%;
                            float: right;

                            .title2 {
                                margin-top: 2vh;
                                line-height: 3.194066749vh;
                                font-size: 1vw;
                            }

                        }

                    }
                }

                ::v-deep .el-carousel__container {
                    height: 65.87268232385661vh !important;
                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__container {
                    position: relative;
                    height: 48.83559950556242vh;
                }

                ::v-deep .el-carousel__arrow {
                    display: none;
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    //cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    //background: #2168DB;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    //z-index:: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 12px;
                }
            }
        }


        .screenmake4 {
            padding: 5.78739184177998vh 5.09763142692085vw;
            width: 100%;
            height: fit-content;
            background: #212a3c;

            .heighLight {
                display: flex;
                justify-content: center;
                text-align: center;
                height: 8.23733003708282vh;
                font-size: 2.2060658579vw;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                font-weight: bold;
                color: white;
                line-height: 4.23733003708282vh;

            }

            .grid {
                margin-top: 2.78739184177998vh;
                position: relative;

                .card {
                    //cursor: pointer;
                    width: 86%;
                    margin: 0 auto;
                    height: fit-content;
                    padding: 0 0.69324090121317vw 0 0;
                    opacity: 1;
                    background: #19202e;

                    .back {
                        border-radius: 9px;
                        display: flex;
                        position: relative;
                        //box-shadow: 5px 0 14px 0px #D4E4FF;
                        height: 58vh;
                        overflow: hidden;
                        background: #19202e;

                        .imgDesign {
                            width: fit-content;
                            max-width: 60%;
                            height: 100%;
                            opacity: 1;
                            background-image: url("../../assets/menage6.png");
                            background-position: center;
                            background-size: cover;
                            background-repeat: no-repeat;
                            background-color: transparent;
                        }

                        .titleDesign {
                            padding: 1.5248454883vh 1.5248454883vw 1.5248454883vh 3.5248454883vw;
                            margin: auto;
                            color: white;
                            width: 35%;
                            float: right;

                            .title1 {
                                font-size: 1.1709416522vw;
                            }

                            .title2 {
                                margin-top: 3vh;
                                line-height: 4vh;
                                font-size: 0.9243212016vw;

                                ::v-deep li {
                                    margin-top: 5px;
                                }

                                ;
                            }


                        }

                    }
                }

                ::v-deep .el-carousel__container {
                    height: 59.87268232385661vh !important;

                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__container {
                    position: relative;
                    height: 48.83559950556242vh;
                }

                ::v-deep .el-carousel__arrow {
                    outline: 10vh;
                    padding: 0;
                    margin: 0;
                    cursor: pointer;

                    border-radius: 50%;
                    width: 55px;
                    height: 55px;
                    background-color: rgba(249, 250, 252, 0.2);
                    border: rgba(255, 255, 255, 0.5) 1px solid;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    z-index: 100;
                    transform: translateY(-50%);
                    text-align: center;
                    font-weight: 800;
                    font-size: 25px;
                }
            }
        }
    }

    .modal-overlay {
        z-index: 999999999;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal-content {
        background-color: #fff;
        padding: 20px;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
    }

    .large-image {
        max-width: 100%;
        max-height: 80vh;
    }
}

.totalmakeHoleModel {
    background: #ebf1fd;
    overflow-x: hidden;
    width: 100vw;
    height: auto;
    position: relative;

    .makeHole1 {
        ////z-index::: 3;
        position: relative;
        width: 100%;

        ////height: 100vh;
        .screen1 {
            ////z-index::: 3;
            position: relative;
            width: 100%;
            height: 670px;
            padding: 2.84301606922126vh 2.86077411900635vw 2.84301606922126vh 2.86077411900635vw;
            background-image: url("../../assets/bannerModel.png");
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-color: transparent;
            /* Add any additional styling as needed */

            .layer2 {
                position: absolute;
                top: 100px;
                left: 9.17157712305026vw;

                .title1 {
                    width: 200px;
                    ;
                    font-size: 3.50606585788562vw;
                    font-family: Sarial, sans-serif, "Microsoft Yahei";
                    font-weight: 400;
                    color: #2f6eff;
                }

                .title2 {
                    margin-top: 5px;
                    width: 95%;
                    height: fit-content;
                    font-size: 14px;
                    font-family: Sarial, sans-serif, "Microsoft Yahei";
                    font-weight: 400;
                    color: #4B5A8B;
                    line-height: 24px;
                }

                .title4 {
                    margin-top: 15px;

                    height: 22px;
                    font-family: Sarial, sans-serif, "Microsoft Yahei";
                    font-weight: 400;
                    font-size: 16px;
                    color: #2f6dfd;
                    line-height: 0px;
                    font-style: normal;
                    text-transform: none;
                }


            }

            .titlle3 {
                //position: absolute;
                //bottom:30px;
                //left:50%;
                //transform: translateX(-60%);
                font-size: 14px;
                font-family: arial, sans-serif, "Microsoft Yahei";
                font-weight: 400;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 9.1px;
                width: fit-content;
                margin: auto;
                padding: 5px 4.6875vw;
                height: 35px;
                color: white;
                background-color: #2f6eff;
                border: 1px solid #2f6eff;
                overflow: hidden;

            }

            //.layer3 {
            //  position: absolute;
            //  top: 5.06798516687268vh;
            //  right: 11.61178509532062vw;
            //  width: 47.42923165800116vw;
            //  height: 72.80593325092707vh;
            //  background-image: url("../assets/GPTplant.png");
            //  background-size: 100% auto;
            //  background-position: center;
            //  background-repeat: no-repeat;
            //  background-color: transparent;
            //  opacity: 1;
            //}
        }

        .screenmake111 {
            //z-index:: 10;

            //left: 10.86077411900635vw;
            width: 100vw;
            height: fit-content;
            padding: 20px 4.6875vw;
            background: white;

            .heighLight {
                text-align: center;
                height: 21px;
                opacity: 1;
                font-size: 21px;
                //color: #53A3F7;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                font-weight: 700;
                line-height: 26px;
            }

            .heightLight2 {
                margin: 19px 2vw;
                text-align: justify;
                width: fit-content;
                height: fit-content;
                font-size: 14px;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                font-weight: 400;
                color: #2C3E50;
                line-height: 20px;
            }

            .grid {
                position: relative;
                height: fit-content;
                display: grid;
                margin-top: 15px;
                grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

                row-gap: 15px;
                column-gap: 10px;



                ::v-deep .el-carousel__container {
                    height: 65.87268232385661vh !important;
                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__container {
                    position: relative;
                    height: 48.83559950556242vh;
                }

                ::v-deep .el-carousel__arrow {
                    display: none;
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    //background: #2168DB;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    //z-index:: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 12px;
                }
            }
        }

        .screenmake3 {
            width: 100vw;
            height: fit-content;
            margin-top: -25px;
            padding: 0 4.6875vw 20px 4.6875vw;
            background: white;

            .heighLight {
                text-align: center;
                height: 21px;
                opacity: 1;
                font-size: 21px;
                //color: #53A3F7;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                font-weight: 700;
                line-height: 26px;
            }

            .heightLight2 {
                margin: 19px 2vw;
                text-align: justify;
                width: fit-content;
                height: fit-content;
                font-size: 14px;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                font-weight: 400;
                color: #2C3E50;
                line-height: 20px;
            }

            .grid {
                position: relative;
                height: fit-content;
                display: grid;
                margin-top: 10px;
                grid-template-columns: minmax(0, 1fr);
                column-gap: 5px;

                .card {
                    cursor: pointer;
                    width: 100%;
                    height: fit-content;
                    display: flex;
                    padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
                    opacity: 1;

                    .title1 {
                        margin: 5px auto;
                        text-align: center;
                        font-size: 16px;
                        font-weight: bold;
                    }

                    .title2 {
                        margin-top: 5px;
                        margin-left: 35px;
                        line-height: 22px;
                        font-size: 14px;
                    }

                    .title3 {
                        margin-top: 5px;

                        line-height: 22px;
                        font-size: 14px;
                    }

                    .titleDesign {
                        // margin: 0 0 0 25px;
                    }

                    .back {
                        width: 100%;
                        background: #ebf1fd;
                        border-radius: 9px;
                        column-gap: 5px;
                        position: relative;
                        padding: 0 0 20px 0;
                        height: fit-content;
                        overflow: hidden;

                        .imgDesign {
                            width: 100%;
                            height: 155px;
                            margin: 0 auto 20px auto;
                            opacity: 1;
                        }


                    }

                }

                ::v-deep .el-carousel__container {
                    height: 65.87268232385661vh !important;
                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__container {
                    position: relative;
                    height: 48.83559950556242vh;
                }

                ::v-deep .el-carousel__arrow {
                    display: none;
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    //background: #2168DB;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    //z-index:: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 12px;
                }
            }
        }

        .screenmake2 {
            padding: 5.78739184177998vh 8.09763142692085vw 5.78739184177998vh 8.09763142692085vw;
            width: 100%;
            height: fit-content;
            background: white;

            .heighLight {
                margin: 0 auto;
                font-weight: bold;
                text-align: center;
                height: 8.23733003708282vh;
                opacity: 1;
                font-size: 2.2060658579vw;
                //color: #53A3F7;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                line-height: 4.23733003708282vh;

            }

            .heightLight2 {
                margin: 0 auto;
                text-align: center;
                height: 13.78739184177998vh;
                font-weight: 400;
                color: #2C3E50;
                line-height: 4.94437577255871vh;

                width: 60.9693818602vw;
                font-size: 1.0287117273vw;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
            }

            .grid {
                margin-top: 2.78739184177998vh;
                position: relative;
                display: grid;
                grid-template-columns: repeat(4, minmax(0, 1fr));
                column-gap: 1.5vw;

                .card {
                    //cursor: pointer;
                    width: 100%;
                    height: fit-content;
                    padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
                    opacity: 1;

                    .titleDesign {
                        z-index: 999;
                        padding: 0;
                        margin: 0 0 0 1.5vw;
                        color: black;
                        width: 100%;
                        float: right;

                        .title1 {
                            margin: 0 auto;
                            text-align: center;
                            font-size: 1.1709416522vw;
                            font-weight: bold;
                        }

                        .title2 {
                            z-index: 999;
                            margin-top: 2vh;
                            text-align: justify;
                            line-height: 3.194066749vh;
                            font-size: 0.9vw;
                        }

                        .title3 {
                            display: grid;
                            grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);

                            margin-top: 2vh;
                            line-height: 3.194066749vh;
                            font-size: 0.8243212016vw;
                        }

                    }

                    .back {
                        border-radius: 9px;
                        //display: flex;
                        position: relative;
                        border: 1px solid white;
                        box-shadow: 2px 0 12px 0px #c9d9f5;
                        background-image: url("../../assets/equipmentBack.png");
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat;
                        background-color: transparent;
                        height: 38vh;
                        padding: 2vh 1.5vw 3vh 1.5vw;
                        overflow: hidden;


                    }

                    .back1 {
                        border-radius: 9px;
                        //display: flex;
                        position: relative;
                        border: 1px solid white;
                        box-shadow: 2px 0 12px 0px #c9d9f5;
                        background-image: url("../../assets/equipmentBack.png");
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat;
                        background-color: transparent;
                        height: 38vh;
                        padding: 2vh 1.5vw 3vh 1.5vw;
                        overflow: hidden;


                    }

                    .back2 {
                        border-radius: 9px;
                        //display: flex;
                        position: relative;
                        border: 1px solid white;
                        box-shadow: 2px 0 12px 0px #c9d9f5;
                        background-image: url("../../assets/equipmentBack.png");
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat;
                        background-color: transparent;
                        height: 38vh;
                        padding: 2vh 1.5vw 3vh 1.5vw;
                        overflow: hidden;


                    }

                    .back3 {
                        border-radius: 9px;
                        //display: flex;
                        position: relative;
                        border: 1px solid white;
                        box-shadow: 2px 0 12px 0px #c9d9f5;
                        background-image: url("../../assets/equipmentBack.png");
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat;
                        background-color: transparent;
                        height: 38vh;
                        padding: 2vh 1.5vw 3vh 1.5vw;
                        overflow: hidden;


                    }
                }

                ::v-deep .el-carousel__container {
                    height: 65.87268232385661vh !important;
                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__container {
                    position: relative;
                    height: 48.83559950556242vh;
                }

                ::v-deep .el-carousel__arrow {
                    display: none;
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    //cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    //background: #2168DB;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    //z-index:: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 12px;
                }
            }
        }

        .screenmake6 {
            //z-index:: 10;

            //left: 10.86077411900635vw;
            width: 100vw;
            height: fit-content;
            padding: 20px 4.6875vw;
            background: transparent;

            .heighLight {
                text-align: center;
                height: 21px;
                opacity: 1;
                font-size: 21px;
                //color: #53A3F7;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                font-weight: 700;
                line-height: 26px;
            }

            .heightLight2 {
                margin: 19px 2vw;
                text-align: justify;
                width: fit-content;
                height: fit-content;
                font-size: 14px;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                font-weight: 400;
                color: #2C3E50;
                line-height: 20px;
            }

            .grid {
                position: relative;
                height: fit-content;
                display: grid;
                margin-top: 10px;
                grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
                column-gap: 5px;

                .card {
                    cursor: pointer;
                    width: 100%;
                    height: fit-content;
                    padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
                    opacity: 1;

                    .title1 {
                        margin: 5px auto;
                        text-align: center;
                        font-size: 16px;
                        font-weight: bold;
                    }

                    .title2 {
                        margin-top: 5px;

                        line-height: 22px;
                        font-size: 14px;
                    }

                    .title3 {
                        margin-top: 5px;

                        line-height: 22px;
                        font-size: 14px;
                    }

                    .titleDesign {
                        margin-top: 10px;
                    }

                    .back {
                        background: white;
                        border-radius: 9px;
                        column-gap: 5px;
                        position: relative;
                        padding: 15px 10px;
                        height: 240px;
                        margin-top: 5px;
                        overflow: hidden;

                        .imgDesign {
                            width: 45px;
                            height: 45px;
                            margin: 0 auto 15px auto;
                            opacity: 1;
                        }


                    }

                }

                ::v-deep .el-carousel__container {
                    height: 65.87268232385661vh !important;
                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__container {
                    position: relative;
                    height: 48.83559950556242vh;
                }

                ::v-deep .el-carousel__arrow {
                    display: none;
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    //background: #2168DB;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    //z-index:: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 12px;
                }
            }
        }


        .screenmake0 {
            //z-index:: 10;

            //left: 10.86077411900635vw;
            width: 100vw;
            height: fit-content;
            padding: 20px 4.6875vw;
            background: white;

            .heighLight {
                text-align: center;
                height: 21px;
                opacity: 1;
                font-size: 21px;
                //color: #53A3F7;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                font-weight: 700;
                line-height: 26px;
            }

            .heightLight2 {
                margin: 19px 2vw;
                text-align: justify;
                width: fit-content;
                height: fit-content;
                font-size: 14px;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                font-weight: 400;
                color: #2C3E50;
                line-height: 25px;
            }

            .grid {
                position: relative;
                height: fit-content;

                .card {
                    cursor: pointer;
                    width: 100%;
                    height: fit-content;
                    padding: 0.98887515451174vh 0.69324090121317vw 0.98887515451174vh 0.69324090121317vw;
                    opacity: 1;

                    .title1 {
                        margin-top: 5px;
                        font-size: 16px;
                        font-weight: bold;
                    }

                    .title2 {
                        margin-top: 5px;

                        line-height: 22px;
                        font-size: 14px;
                    }

                    .titleDesign {
                        margin-top: 20px;
                    }

                    .title3 {
                        margin-top: 5px;
                        display: grid;
                        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
                        line-height: 22px;
                        font-size: 14px;
                    }

                    .back {
                        margin-top: 15px;
                        background: white;
                        border-radius: 9px;
                        position: relative;
                        //height:580px ;
                        overflow: hidden;

                        .imgDesign {
                            width: 100%;
                            height: fit-content;
                            opacity: 1;
                            background-position: center;
                            background-size: cover;
                            background-repeat: no-repeat;
                            background-color: transparent;
                        }


                    }

                }

                ::v-deep .el-carousel__container {
                    height: 65.87268232385661vh !important;
                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__container {
                    position: relative;
                    height: 48.83559950556242vh;
                }

                ::v-deep .el-carousel__arrow {
                    display: none;
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    //background: #2168DB;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    //z-index:: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 12px;
                }
            }

            .grid1 {
                position: relative;
                height: fit-content;
                display: grid;
                margin-top: 25px;
                grid-template-columns: minmax(0, 1fr);
                column-gap: 0;

                .card {
                    border-radius: 9px;
                    cursor: pointer;
                    width: 100%;
                    height: fit-content;
                    background-color: white;
                    padding: 0 10px;
                    opacity: 1;

                    .title1 {
                        height: fit-content;
                        font-size: 16px;
                        font-weight: bold;
                    }

                    .title2 {
                        margin: 10px 5px 10px 0;
                        text-align: justify;
                        line-height: 22px;
                        font-size: 14px;
                    }

                    .titleDesign {}

                    .title3 {
                        margin-top: 5px;
                        display: grid;
                        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
                        line-height: 22px;
                        font-size: 14px;
                    }

                    .back {
                        margin-top: 15px;
                        border-radius: 9px;
                        position: relative;
                        //height:580px ;
                        overflow: hidden;

                        .imgDesign {
                            width: 80px;
                            height: fit-content;
                            margin: 0 10px 0 5px;
                            opacity: 1;
                            background-position: center;
                            background-size: contain;
                            background-repeat: no-repeat;
                            background-color: transparent;
                        }


                    }

                }

                ::v-deep .el-carousel__container {
                    height: 65.87268232385661vh !important;
                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__container {
                    position: relative;
                    height: 48.83559950556242vh;
                }

                ::v-deep .el-carousel__arrow {
                    display: none;
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    //background: #2168DB;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    //z-index:: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 12px;
                }
            }
        }


        .screenmake4 {
            //left: 10.86077411900635vw;
            width: 100vw;
            height: fit-content;

            padding: 20px 4.6875vw;
            background: black;

            .heighLight {
                text-align: center;
                height: 21px;
                opacity: 1;
                font-size: 21px;
                color: white;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                font-weight: 700;
                line-height: 26px;
            }

            .heightLight2 {
                margin: 19px 2vw;
                text-align: justify;
                width: fit-content;
                height: fit-content;
                font-size: 14px;
                font-family: Sarial, sans-serif, "Microsoft Yahei";
                font-weight: 400;
                color: #2C3E50;
                line-height: 20px;
            }

            .grid {
                margin-top: 2.78739184177998vh;
                position: relative;

                .arrowButtonleft {
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    background: white;
                    color: black;
                    position: absolute;
                    top: 50%;
                    left: -55px;
                    ////z-index::: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 1.2432120161756vw;
                    font-weight: bold;
                }

                .arrowButtonright {
                    border: none;
                    outline: 0;
                    padding: 0;
                    margin: 0;
                    cursor: pointer;
                    transition: 0.3s;
                    border-radius: 0;
                    width: 1.15540150202195vw;
                    height: 4.32632880098888vh;
                    background: white;
                    color: black;
                    position: absolute;
                    top: 50%;
                    right: -55px;
                    ////z-index::: 10;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 1.2432120161756vw;
                    font-weight: bold;
                }

                .card {
                    cursor: pointer;
                    width: 98%;
                    margin: 0 auto;
                    min-height: 250px;
                    padding: 0 0.69324090121317vw 0 0;
                    opacity: 1;
                    background: #19202e;

                    .back {
                        border-radius: 9px;
                        position: relative;
                        //box-shadow: 5px 0 14px 0px #D4E4FF;
                        min-height: 280px;
                        overflow: hidden;
                        background: #19202e;

                        .imgDesign {
                            width: 100%;
                            height: 214px;
                            opacity: 1;
                            background-image: url("../../assets/menage6.png");
                            background-position: center;
                            background-size: cover;
                            background-repeat: no-repeat;
                            background-color: transparent;
                        }

                        .titleDesign {
                            padding: 15px 20px 25px 20px;
                            color: white;
                            width: 100%;
                            float: right;

                            .title1 {
                                font-size: 16px;
                            }

                            .title2 {
                                margin-top: 15px;
                                line-height: 22px;
                                font-size: 14px;

                                ::v-deep li {
                                    margin-top: 5px;
                                }

                                ;
                            }


                        }

                    }
                }

                ::v-deep .el-carousel__container {
                    height: 390px !important;

                }

                .el-carousel__item h3 {
                    color: white;
                    opacity: 0.75;
                    margin: 0;
                }

                .el-carousel__item:nth-child(2n) {
                    background-color: transparent;
                }

                .el-carousel__item:nth-child(2n+1) {
                    background-color: transparent;
                }

                ::v-deep .el-carousel__arrow {
                    display: block;
                    //border: 1px solid white;
                    outline: -5px;
                    padding: 0;
                    margin: -68px -10px;
                    cursor: pointer;

                    border-radius: 0;
                    width: 25px;
                    height: 48px;
                    background: rgba(245, 246, 250, 0.8);
                    color: #131313;
                    position: absolute;
                    top: 50%;
                    ////z-index::: 100;
                    transform: translateY(-50%);
                    text-align: center;
                    font-size: 14px;
                }
            }
        }
    }

}
</style>
